import * as types from './types'

/**
 * 更新步骤状态
 * @param {Object} param0
 * @param {Object} payload 包含 index 和 status
 */
export const updateStepStatus = ({ commit }, payload) => {
  commit(types.UPDATE_STEP_STATUS, payload)
}

/**
 * 更新提交信息
 * @param {Object} param0
 * @param {Object} payload 包含 step 和 data
 */
export const updateSubmitInfo = ({ commit }, payload) => {
  commit(types.UPDATE_SUBMIT_INFO, payload)
}

/**
 * 更新当前活动步骤
 * @param {Object} param0
 * @param {Number} active 当前活动步骤
 */
export const updateActive = ({ commit }, active) => {
  console.log('active', active)
  commit(types.UPDATE_ACTIVE, active)
}

/**
 * 更新步骤完成情况
 * @param {Object} param0
 * @param {Number} step 完成的步骤
 */
export const updateStepComplete = ({ commit }, step) => {
  commit(types.UPDATE_STEP_COMPLETE, step)
}

/**
 * 设置步骤信息
 * @param {Object} param0
 * @param {Object} payload 包含 stepInfo, type 和 isHasEdit
 */
export const setStepInfo = ({ commit }, payload) => {
  commit(types.SET_STEP_INFO, payload)
}
